import { Component, OnInit, inject } from '@angular/core';
import { Observable, Subscription, map, catchError, of } from 'rxjs';
import { Entity } from 'src/app/core/models/entity.model';
import { GazeMap } from 'src/app/core/models/gaze-map';
import { Pagination, PaginationRequest, PaginationDynamoRequest, PaginationDynamoFiltersRequest, PaginationDynamoFiltersDateRequest, DynamoPage } from 'src/app/core/models/pagination.model';
import { User } from 'src/app/core/models/user.model';
import { GazeMapService } from 'src/app/core/services/gaze-map.service';
import { LoginService } from 'src/app/core/services/login.service';
import { TeamScopeService } from 'src/app/core/services/team-scope.service';
import * as utils from 'src/app/shared/helpers/utils';
import { formatDate, Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { PaginationService } from 'src/app/core/services/pagination.service';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'hbo-gaze-map-list',
  templateUrl: './gaze-map-list.component.html',
  styleUrls: ['./gaze-map-list.component.scss']
})
export class GazeMapListComponent implements OnInit {

  gazeMaps$ = new Observable<Pagination<GazeMap>>;


  user: User = utils?.localStorageGetItem('user');

  entities_filter!: Entity[];
  types_filter!: Array<{ value: string; label: string }>;

  prevDynamoKey!: string;
  lastDynamoKey!: string;
  fullLastDynamoKey!: string;

  columns!: string[];

  shortTestID: boolean = false;

  private readonly teamScope = inject(TeamScopeService);

  constructor(
    private configSvc: ConfigService,
    private ddbbUtils: DdbbUtils,
    private gazeMapService: GazeMapService,
    public dynamoPaginationService: PaginationService,
    private loginService: LoginService,
    private translate: TranslateService,
    private _location: Location
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
  }

  ngOnInit() {
    this.dynamoPaginationService.resetGazeMapPagination();
    this.dynamoPaginationService.resetFitPagination();
    //child entities refresh strategy, recover entity childs every time we acces to the section
    //this.ddbbUtils.getEntityChilds(this.user.entityId).then(result => {
      /*this.user.childEntities = result;
      utils.localStorageSetItem('user', this.user);*/
      this.gazeMapService.currentGazeMapConfigValue.pagination
        ? this.searchGazeMaps(this.gazeMapService.currentGazeMapConfigValue.pagination)
        : null;
      let storageMimesysFilter = JSON.parse(localStorage.getItem('mimesysFilter')!) as PaginationDynamoRequest
      storageMimesysFilter
        ? (
          this.gazeMapService.setCurrentGazeMapParamConfig('pagination', storageMimesysFilter),
          this.searchGazeMaps(storageMimesysFilter)
        )
        : this.searchGazeMaps()
    //});

  }

  getColumns(gazeMaps: any) {
    this.user.roleId == 4
      ? this.columns = ['testId', 'alias', 'aplicacion_name', 'date', 'created_at_non_utc', 'referencia', 'results']
      : this.columns = ['testId', 'alias', 'aplicacion_name', 'date', 'created_at_non_utc', 'created_at', 'idCliente', 'referencia', 'results']
    if (!gazeMaps.shortTestID && this.user.roleId != 1) {
      this.columns = this.columns.filter(e => e !== 'alias');
    } else {
      this.shortTestID = true;
    }
    return this.columns
  }

  getAplicacionNameTranslated(aplicacionName: string): string {
    const translations: { [key: string]: string } = {
      'progressive': 'MIMESYS.PROGRESSIVE',
      'svision': 'MIMESYS.SINGLEVISION',
      'office': 'MIMESYS.OFFICE'
    };

    return translations[aplicacionName] || aplicacionName;
  }

  searchGazeMaps(pagination?: PaginationDynamoRequest) {


    this.loginService.userStore.subscribe(user => {
      user.childEntities = this.user.childEntities;
      this.entities_filter = user.childEntities!.filter(entity => entity.entityTypeId == 4);
      this.types_filter = [
        { value: 'progressive', label: 'MIMESYS.PROGRESSIVE' },
        { value: 'svision', label: 'MIMESYS.SINGLEVISION' },
        { value: 'office', label: 'MIMESYS.OFFICE' }
      ];
      let queryStringParams: PaginationDynamoRequest = {};
      let queryStringParamsArray: any[] = [];
      queryStringParams.role = this.user.role?.id;
      queryStringParams.internal = true;
      queryStringParams.per_page = pagination?.perPage || 10;
      ///determine usin prev, last and reverse keys
      !pagination?.dynamoReverse
        ? pagination?.dynamoLastKey
          ? queryStringParams.last_key = pagination?.dynamoLastKey
          : null
        : pagination?.dynamoPrevKey && pagination?.page! > 1
          ? queryStringParams.last_key = pagination?.dynamoPrevKey
          : null;
      !pagination?.dynamoReverse
        ? queryStringParams.reverse_search = false
        : pagination?.page! > 1 || pagination?.page! < 0
          ? queryStringParams.reverse_search = pagination?.dynamoReverse
          : null;
      let filters: PaginationDynamoFiltersRequest = {};
      let date: PaginationDynamoFiltersDateRequest = {};
      //dates
      pagination?.filter_params
        ? pagination.filter_params!['entities'] = this.gazeMapService.currentGazeMapConfigValue.shops_selected
        : null;
      let partners: string;
      let distributors=undefined;
      pagination?.filter_params && pagination?.filter_params!['entities'] && pagination?.filter_params!['entities'].length
        ? partners = pagination.filter_params!['entities'].map((entity: { internalCode: string; id: number; }) => entity.id).join('+')
        : this.user.role?.id != 4
          ? partners = user.childEntities!.filter(entity => entity.entityTypeId == 4).map(entity => entity.id).join('+')
          : partners = `${user.entity.id}`;

      switch (this.user.roleId) {
        case 1:
          distributors = this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.length ?
            this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.filter((entity: Entity) => entity.entityTypeId == 2).map((entity: Entity) => entity.id).join('+'):
            this.user.horizonsTeamId == null ?
              this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 2).map((entity: Entity) => entity.id).join('+'):
              this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 2 && entity.horizonsTeamId == this.user.horizonsTeamId ).map((entity: Entity) => entity.id).join('+');
          partners = this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.length ?
            this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.id).join('+') :
            this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.id).join('+');
          break;
        case 2:
          distributors = this.user.entityId.toString();
          partners = this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.length ?
            this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.id).join('+') :
            this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 4 && this.teamScope.isInScope(entity.teamId)).map((entity: Entity) => entity.id).join('+');
          break;
        case 4:
          partners = this.user.entityId.toString();
          break;
        default:
          this.user.roleId == 2 ? distributors = this.user.entityId.toString(): null
          partners = this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.length ?
            this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.filter((entity: Entity) => entity.entityTypeId == 4).map((entity: Entity) => entity.id).join('+') :
            this.configSvc.currentConfigValue.childEntities?.filter((entity: Entity) => entity.entityTypeId == 4 && this.teamScope.isInScope(entity.teamId)).map((entity: Entity) => entity.id).join('+');
          break;
      }
     
      if (pagination?.filter_params!) {
        filters.date = {};
        pagination?.filter_params!['startDate'] != ''
          ? filters.date.init = pagination?.filter_params!['startDate']
          : null;
        pagination?.filter_params!['endDate'] != ''
          ? filters.date.end = pagination?.filter_params!['endDate']
          : null;
        pagination?.filter_params!['type'] && pagination?.filter_params!['type'] != ''
          ? filters['aplicacion_name_filter'] = pagination?.filter_params!['type']
          : null;
        pagination?.filter_params!['deleted']
          ? filters['hidden'] = pagination?.filter_params!['deleted'] ? 'True' : 'False'
          : null;
      } else {
        const now = new Date();
        // Note: months are returned in 0-11 format instead of 1-12, that is why we add 1 before converting it to string
        let now_str = `${now.getUTCFullYear()}-${(now.getUTCMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits:2})}-${now.getUTCDate()}`
        filters.date = { end: now_str };
        /*if (this.user.role?.id == 1) {
          filters.date.init = formatDate(new Date(new Date().getTime() - (60 * 60 * 24 * 7 * 1000)), 'yyyy-MM-dd', 'en')
        }*/
      }

      /*filters.date = date;
      filters.date!.end = "";
      filters.date!.init = "";*/
      pagination?.search_params ? queryStringParams.search_params = pagination?.search_params : null;
      pagination?.sort
        ? queryStringParams.sort = pagination?.sort
        : null;
      pagination?.order
        ? queryStringParams.order = pagination?.order
        : null;
      if (distributors && distributors.length > 0){
        // this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied ? filters['shop_id'] = partners : delete filters['shop_id'];
        // Add distributor filter to reduce dynamoDB query complexity
        filters['distributor_id'] = distributors;
      }
      !pagination?.filter_params || (pagination?.filter_params && !pagination?.filter_params!['entities'])
          ? this.user.roleId === 1 && ( this.user.teamId ==null && this.user.horizonsTeamId ==null && !this.configSvc.currentConfigValue.gazeMapsEntitiesSelectedApplied?.length) ? delete filters['shop_id'] && delete filters['distributor_id'] : filters['shop_id'] = partners
          : filters['shop_id'] = partners;
      if(!queryStringParams['sort'] ){
        filters['sort']='created_at';
        filters['order']='desc'
      }
      queryStringParams.filter_params = filters;
      pagination?.search_with_entity && (queryStringParams.search_entity = pagination.search_with_entity);
      // if not search_param, delete search_with_entity
      if (!pagination?.search_params || pagination?.search_params == '') {
        delete queryStringParams.search_entity;
      }
      // const search_params = pagination?.search_with_entity ? pagination?.search_with_entity : pagination?.search_params;
      Object.entries(queryStringParams).map(elem => {
        elem[0] == 'filter_params'
          ? queryStringParamsArray.push(`${elem[0]}=${btoa(JSON.stringify(elem[1]))}`)
          : elem[0] == 'search_params'
            ? queryStringParamsArray.push(`${elem[0]}=${pagination?.search_params?.trim()}`)
          : queryStringParamsArray.push(`${elem[0]}=${elem[1]}`)
      });
      let testBase64 = btoa(JSON.stringify(filters))


      this.gazeMaps$ = this.gazeMapService.index(queryStringParamsArray.join('&'), this.translate.currentLang)
      .pipe(
          catchError(error => {
            console.log('Error fetching gaze maps:', error);
            return of({
              ancestors: {},
              backoffice_shop_ids: [],
              data: [],
              last_key: null,
              original_last_key: {},
              shortTestID: false,
              params: {}
            });
          }),
          map(gazeMaps => (
            console.log('Gaze Maps:', gazeMaps),
            {
            shortTestID: gazeMaps.shortTestID,
            total: gazeMaps.data ? gazeMaps.data.length : 0,
            perPage: pagination?.perPage || 10,
            currentPage: pagination?.page || 1,
            lastPage: 1,
            from: 1,
            to: gazeMaps.data ? gazeMaps.data.length : 0,
            data: gazeMaps.data ? (pagination?.dynamoReverse ? gazeMaps.data.reverse() : gazeMaps.data) : [],
            dynamoLastKey: this.setPrevKey(pagination?.page, pagination?.sort || queryStringParams.sort, gazeMaps.data ? gazeMaps?.data[0] : {}, gazeMaps.last_key, pagination!),
            dynamoPrevKey: pagination?.dynamoPrevKey || null,
            dynamoFullLastKey: gazeMaps.full_last_key || null,
            dynamoReverse: pagination?.dynamoReverse || false,
            sort: pagination?.sort || queryStringParams.sort,
            order: pagination?.order || queryStringParams.order,
            search_params: pagination?.search_params || queryStringParams.search_params,
            search_with_entity: pagination?.search_with_entity,
            filter_params: pagination?.filter_params || queryStringParams.filter_params,
            showFilters: pagination?.showFilters || false,
            role: pagination?.role || queryStringParams.role,
            roleId: pagination?.roleId || this.user.role?.id,
            selectorEntitiesSearch: pagination?.selectorEntitiesSearch || ''
          }
        ))
      )
    });
  }

  getClientName(_id: number) {
    if (this.user.role?.id != 4) {
      return `${this.user.childEntities!.find(child => child.id == _id)?.name}(${_id})`
    } else {
      return `${this.user.entity.name}(${_id})`
    }

  }


  getParentEntity(_id: number) {
    if (this.user.role?.id != 4) {
      return `${this.user.childEntities!.find(child => child.id == _id)?.parentEntityId}`
    } else {
      return `${this.user.entity.parentEntityId}(${_id})`
    }

  }

  setPrevKey(_page: number = 1, _sort: string | undefined, _previous: GazeMap, _key: string, _pagination: PaginationRequest) {
    _pagination && _previous
      ? (
        /*this.prevDynamoKey = this.base64Previous(_sort, _previous),//clone*/
        this.lastDynamoKey = _key
      )
      : this.lastDynamoKey = _key
    let dynamoPage: DynamoPage = {
      page: _page,
      lastKey: _key,
      prevKey: this.prevDynamoKey,
      visible: true,
      hide: false
    }
    this.dynamoPaginationService.setCurrentGazeMapsDynamoPage(dynamoPage);
    return _key
  }
  base64Previous(_sort: string | undefined, _previous: GazeMap) {
    let previous: any = { 'status': '', 'testId': '', 'type': '' };
    previous.status = _previous.status;
    previous.testId = _previous.testId;
    previous.type = _previous.type;
    _sort
      ? previous[_sort] = _previous[_sort]
      : null
    return btoa(JSON.stringify(previous))
  }

  persistanceFilters(_clientId?: number) {

    this.gazeMapService.currentGazeMapConfigValue.pagination
      ? localStorage.setItem('mimesysFilter', JSON.stringify(this.gazeMapService.currentGazeMapConfigValue.pagination))
      : null;

    let data_entities = this.user.childEntities!.find((entity: Entity) => entity.id === _clientId)!;
    this.gazeMapService.setCurrentGazeMapParamSettings('clientId', _clientId);
    this.gazeMapService.setCurrentGazeMapParamSettings('parentEntityId', this.getParentEntity(_clientId!));
    this.gazeMapService.setCurrentGazeMapParamSettings('userChildEntities', data_entities);
  }

}

